import { isDefined } from '../generic/generic';

type DocumentValidationKeyParts = {
  messageId?: string;
  relationshipId?: string;
  sourceMessageId?: string;
};

/**
 * Identity the datachecks guard compares to decide whether a validation result still belongs to the
 * document on screen. Key on whatever selects the field paths: an existing message is identified by
 * its own id, while a document being created is identified by the receiver-process-spec inputs
 * (relationship, plus source message when creating from one) — those alone select the spec, and the
 * document type is implied by the relationship, which is scoped to a single `message_type`.
 *
 * Parts are labelled so a relationship id can never read as a message id, and returns `undefined`
 * when no identity is available, which disables the guard rather than guessing at one.
 */
export const buildDocumentValidationKey = ({
  messageId,
  relationshipId,
  sourceMessageId,
}: DocumentValidationKeyParts): string | undefined => {
  const parts = [
    messageId ? `message:${messageId}` : null,
    relationshipId ? `relationship:${relationshipId}` : null,
    sourceMessageId ? `source:${sourceMessageId}` : null,
  ].filter(isDefined);

  return parts.length > 0 ? parts.join('|') : undefined;
};
